import clsx from "clsx";

import { ArrowRight } from "@components/Icons";

const FileDownloadButtons = ({ files, width = "sm", alignment = "left" }) => {
	return (
		<div>
			{files.map((file) => {
				return (
					<div
						key={file.id}
						className={clsx("DownloadButtons__button", "mb-4")}
					>
						<a
							href={file.url}
							target="_blank"
							rel="noreferrer"
							className={clsx(
								"DownloadButton",
								"flex items-center",
								"bg-purple-01",
								"text-white-01",
								"px-4 py-2",
								"transition-colors",
								"rounded-sm",
								"hover:bg-black-01",
								{
									"max-w-[320px]": width === "sm",
									"max-w-md": width === "md",
									"max-w-lg": width === "lg",
									"mx-auto": alignment === "center",
								}
							)}
						>
							<div>{`Download`}</div>
							<div className={clsx("DownloadButton__icon", "ml-4")}>
								<ArrowRight />
							</div>
						</a>
					</div>
				);
			})}
		</div>
	);
};

export default FileDownloadButtons;
